/**
 * Counts the number of # characters in a string
 *
 * @param str - The string with possible hashtags in it
 * @returns 0 or how many hashtags are in the string
 */
export function countHashtagsInString(str: string): number {
    return (str.match(/#/g) ?? []).length;
}
